import { render, staticRenderFns } from "./TarjetaPie.vue?vue&type=template&id=7716df0c&scoped=true"
import script from "./TarjetaPie.vue?vue&type=script&lang=js"
export * from "./TarjetaPie.vue?vue&type=script&lang=js"
import style0 from "./TarjetaPie.vue?vue&type=style&index=0&id=7716df0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7716df0c",
  null
  
)

export default component.exports